import React from 'react';
import ReactTable from 'react-table';
import { Redirect } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import i18next from "i18next";

import { DevicesRegistrationService, TimeFormattingService } from "../../services";

class DeviceRegistrationList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDeleteModal: false,
            deviceDetailId: null,
            registrationToDeregister: null,
            loading: false,
            registrations: props.registrations,
            filteredRegistrations: props.registrations,
            serialSearchValue: null,
            searchTimeout: null
        }
    }

    viewDeviceLinkClick(device) {
        this.setState({
            deviceDetailId: device.id
        })
    }

    deRegisterClick(registration) {
        this.setState({ registrationToDeregister: registration }, () => {
            this.toggleDeleteModal();
        });
    }

    confirmedDeRegisterClick() {
        this.setState({ loading: true });
        DevicesRegistrationService.deregisterDevice(this.state.registrationToDeregister.deviceSerialNumber).then((_) => {
            this.props.handleLocalSuccess(i18next.t('messages.device-de-registered'));
        }).catch((err) => {
            console.error(err);
            if (err?.response?.data?.errorMessage) {
                this.props.localErrorHandler(`Error de-registering device: ${err?.response?.data?.errorMessage}`);
            } else {
                this.props.localErrorHandler("Error de-registering device.");
            }
        }).finally(() => {
            this.setState({ loading: false });
            this.toggleDeleteModal();
            this.props.refreshFunction();
        });
    }

    toggleDeleteModal() {
        this.setState({showDeleteModal: !this.state.showDeleteModal});
    }

    renderNormalTime(value) {
        const date = TimeFormattingService.renderDate(value);
        const time = TimeFormattingService.renderTime(value);
        return (<span>{ date }<br />{ time }</span>);
    }

    doSearch(val) {
        const searchValue = val.target.value;
        this.setState({ serialSearchValue: searchValue });
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
        this.state.searchTimeout = setTimeout(() => {
            this.setState({
                filteredRegistrations: searchValue ? this.state.registrations.filter(registration => registration.deviceSerialNumber.includes(searchValue)) : this.state.registrations
            });
        }, 500);
    }
    
    render() {
        if (this.state.deviceDetailId) {
            return (
                <Redirect to={{ pathname: `/config/devices/view/${this.state.deviceDetailId}` }}/>
            );
        }

        return (
            <div className="card-block add-margin-top">
                <div className="react-table-custom">
                    <ReactTable
                        className="-striped -highlight"
                        data={this.state.filteredRegistrations}
                        showPaginationTop
                        loading={this.props.loading || this.state.loading}
                        columns={[
                            {
                                Header: 'Serial Number',
                                accessor: "deviceSerialNumber",
                                width: 300,
                                minResizeWidth: 200,
                                filterable: true,
                                Filter: <div className="filter">
                                <i className="table-search-icon" />
                                <input
                                    style={{ width: '100%', margin: '0 auto' }}
                                    value={this.state.serialSearchValue}
                                    onChange={this.doSearch.bind(this)}
                                    type="text"
                                    name="search"
                                    className="table-search-box"
                                    autoComplete="off"
                                />
                                </div>
                            },
                            {
                                Header: 'Associated Device',
                                accessor: "device.displayName",
                                Cell: cell => cell.value ? <span>{cell.value}</span> : <span>{ i18next.t('none') }</span>,
                                width: 300,
                                minResizeWidth: 200
                            },
                            {
                                Header: 'Associated Device Time',
                                accessor: "device.lastDeviceTime",
                                Cell: cell => cell.value ? <span>{this.renderNormalTime(cell.value)}</span> : <span>{ i18next.t('none') }</span>,
                                width: 300,
                                minResizeWidth: 200
                            },
                            {
                            Cell: cell => <RowButtons 
                                                deRegisterClick={this.deRegisterClick.bind(this)} 
                                                viewDeviceClick={this.viewDeviceLinkClick.bind(this)} 
                                                registration={cell.original} 
                                            />,
                            sortable: false,
                            minResizeWidth: 50
                          }
                        ]}
                    />
                </div>

                <Modal show={this.state.showDeleteModal} onHide={this.toggleDeleteModal.bind(this)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{i18next.t('pages.actions.de-register-action')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.registrationToDeregister ? 
                            <div>
                                <p>{i18next.t('messages.are-you-sure-de-register')} <br/> <br/> <strong>{this.state.registrationToDeregister.deviceSerialNumber}</strong></p> <br />
                            </div> : null
                        }                        
                    </Modal.Body>
                    <Modal.Footer>
                        <a className="btn btn-danger" onClick={this.confirmedDeRegisterClick.bind(this)}>{i18next.t('delete')}</a>
                        <Button onClick={this.toggleDeleteModal.bind(this)}>{i18next.t('form-labels.cancel')}</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );        
    }
}

const RowButtons = (props) => {
    return (
        <div className="text-left">
            {
                props.registration.device ? (<span><button className="btn btn-sm btn-default" onClick={() => props.viewDeviceClick(props.registration.device)}>{ i18next.t('pages.device-registrations.view-device') }</button> &nbsp;</span>) : null
            }
            <button className="btn btn-sm btn-default" onClick={() => props.deRegisterClick(props.registration)}>{ i18next.t('pages.device-registrations.de-register') }</button>
        </div>
    );
}

export default DeviceRegistrationList;